import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SafeHtmlPipe } from './pipe.safehtml';
import { EllipsisPipe } from './pipe.ellipsis';
import { UtcDatePipe } from './pipe.utcdate';
import { SafeUrlPipe } from './pipe.safeUrl';
import { SafeStylePipe } from './pipe.safestyle';
import { TZDatePipe } from './pipe.tzDate';
import { RoundUpTo100Pipe } from './round-up-to100.pipe';
import { MillionShorthandPipe } from './million-shorthand.pipe';
import { SplitTextPipe } from './split-text.pipe';
import { DecimalPipe } from '@angular/common';
@NgModule({
    imports: [
        CommonModule,
        SafeHtmlPipe,
        EllipsisPipe,
        UtcDatePipe,
        SafeUrlPipe,
        SafeStylePipe,
        TZDatePipe,
        RoundUpTo100Pipe,
        MillionShorthandPipe,
        SplitTextPipe,
    ],
    exports: [
        SafeHtmlPipe,
        EllipsisPipe,
        UtcDatePipe,
        SafeUrlPipe,
        SafeStylePipe,
        TZDatePipe,
        RoundUpTo100Pipe,
        MillionShorthandPipe,
        SplitTextPipe
    ],
    providers: [
        DecimalPipe
    ],
})
export class PipesModule { }
